module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAEmSURBVHgBrVTbbYNAEFxO/IcOQjqghKSClBB3EKcBuAD/Nh3QQioIHRh3cCVcATw8Yx2WbQESxiOt9rTszc0NC5Jl2TdDVsLvum6PbBGFrIByOZCVUPIk+PIg8jz/apomwvJXa21nidAQKqUS+Mhmc11v23bveV7Q9/0fSpWaIQnQ+I/GDfIhSZLt8Ix1JJIU6Ktmr0YlaAyxNAgq26Vp+goSC4VDXQ/9/oSaDUiowCB/IL+DgMRbxLmHdXpzOXiEJOQmd4WzN4jSERpHcuPZlCLOFMnKOI7LqwO48Q05QtT3m8YU1TwdPvzI+LXrsfqUR5UsxNMmm0TWqQhlBTwQaPeWDHIBb+xyGqnoEX8jn4gIJu9AJg/AXnZxCEmGCX6RhcB3dzwBAKeTRDcAVPUAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon/analytic-dashboard.png
// module id = GJbA
// module chunks = 46